"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._selectGameVendorSettingsStatus = exports.selectGameVendorSettingsStatus = exports.selectGameVendorSettings = exports.selectGameVendorSettingsFetchItems = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const slice_1 = require("./slice");
const selectGameVendorSettingsFetchItems = (state) => state.gameVendorSettings.fetchItems || slice_1.initialState.fetchItems;
exports.selectGameVendorSettingsFetchItems = selectGameVendorSettingsFetchItems;
const selectGameVendorSettings = (state) => state.gameVendorSettings.gameVendorSettings || slice_1.initialState.gameVendorSettings;
exports.selectGameVendorSettings = selectGameVendorSettings;
/**
 * @deprecated
 */
const selectGameVendorSettingsStatus = (vendor) => (0, toolkit_1.createSelector)(exports.selectGameVendorSettingsFetchItems, exports.selectGameVendorSettings, ({ loading }, settings) => {
    const enabled = settings[vendor];
    return {
        loading,
        enabled,
    };
});
exports.selectGameVendorSettingsStatus = selectGameVendorSettingsStatus;
exports._selectGameVendorSettingsStatus = (0, toolkit_1.createSelector)([
    exports.selectGameVendorSettingsFetchItems,
    exports.selectGameVendorSettings,
    (_, vendor) => vendor,
], ({ loading }, settings, vendor) => {
    const enabled = settings[vendor];
    return {
        loading,
        enabled,
    };
});
//# sourceMappingURL=selectors.js.map